const o = /* @__PURE__ */ Symbol("elTooltip");
export {
  o as TOOLTIP_INJECTION_KEY
};
